// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3042":"css/admin-app.6999","4653":"css/app.6999"}[chunkId] + ".css";
};